import React from "react";
import "./styles.scss";
import { useParams } from "react-router-dom";
import ProductPartial from "../ProductPartial";
import { getFilesByParam } from "../../utils/helper"; 

const Category = () => {
  const { param } = useParams();
  const files = getFilesByParam(param);

  return (
    <> 
      <ProductPartial
        dataprop={{
          files,
          param,
        }}
      />
    </>
  );
};

export default Category;
